













import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
  }
})

export default class InputHelperTextComponent extends Vue {
  @Prop() public error!: boolean;
  @Prop() public errorMsg?: string;
  @Prop() public info?: boolean;
  @Prop() public infoMsg?: string;
  @Prop() public inactive?: boolean;
}
